import { KeyboardEvent, MouseEvent } from "react";
import {
  ODSCardImageHeadingLevel,
  ODSCardImagePosition,
  ODSCardImageProps,
  ODSCardImageSize,
} from "./ODSCardImage.types";

export {
  getCardImageHeadingTag,
  generateCardImageTabIndex,
  getHeadingAriaLabel,
  onCardImageActionSlotClick,
  onCardImageActionSlotKeyDown,
  normalizeSizeAndPosition,
};

// TODO: remove in next major release
function getCardImageHeadingTag(level?: ODSCardImageHeadingLevel): string {
  return `h${level ?? 2}`;
}

// TODO: remove in next major release
function generateCardImageTabIndex(
  props: Pick<ODSCardImageProps, "tabIndex" | "action">
): number {
  const { tabIndex, action } = props;
  if (!action) return -1;
  return tabIndex ?? 0;
}

// TODO: remove in next major release
function getHeadingAriaLabel(
  props: Pick<ODSCardImageProps, "label" | "title">
): string {
  const { label, title } = props;
  const spacer = label && title ? " " : "";
  return `${label}${spacer}${title}`;
}

function onCardImageActionSlotClick(event: MouseEvent): void {
  event.preventDefault();
  event.stopPropagation();
}

function onCardImageActionSlotKeyDown(event: KeyboardEvent): void {
  const { key } = event;
  if (key !== "Enter" && key !== " ") return;
  event.preventDefault();
  event.stopPropagation();
}

function normalizeSizeAndPosition(
  size: ODSCardImageSize,
  imagePosition: ODSCardImagePosition
): { size: ODSCardImageSize; imagePosition: ODSCardImagePosition } {
  const isLarge = size === "hero" || size === "large";
  const isSmall = size === "medium" || size === "small";
  const isHorizontal = imagePosition === "left" || imagePosition === "right";
  const isVertical = imagePosition === "top" || imagePosition === "bottom";
  if ((isLarge && isHorizontal) || (isSmall && isVertical))
    return { size, imagePosition };

  if (isLarge && isVertical) return { size, imagePosition: "right" };
  if (isSmall && isHorizontal) return { size, imagePosition: "top" };
  return { size: "hero", imagePosition: "right" };
}
